"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SzAlert = void 0;
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../..");
exports.SzAlert = function (_a) {
    var children = _a.children, variant = _a.variant, transparent = _a.transparent, onClose = _a.onClose, className = _a.className;
    var containerClasses = classnames_1.default('sz-alert pl-3 d-flex align-items-center', className, {
        'pr-4  py-0': !onClose,
        'pr-3  py-1': onClose
    }, {
        'border-0': !transparent,
        'bg-success-light': !transparent && variant === 'success',
        'bg-warning-light': !transparent && variant === 'warning',
        'bg-danger-light': !transparent && variant === 'danger',
        'bg-info-light': !transparent && variant === 'info'
    }, {
        'border-success': transparent && variant === 'success',
        'border-warning': transparent && variant === 'warning',
        'border-danger': transparent && variant === 'danger',
        'border-info': transparent && variant === 'info'
    });
    var icon = classnames_1.default({
        'alert-triangle': variant === 'danger' || variant === 'warning',
        'information-circle': variant === 'info',
        'check-circle-1': variant === 'success'
    });
    return (react_1.default.createElement(react_bootstrap_1.Alert, { className: containerClasses },
        react_1.default.createElement(__1.SzIcon, { variant: "bold", icon: icon, className: classnames_1.default('mr-3', "text-" + variant) }),
        react_1.default.createElement(__1.SzTypographie, { variant: "caption", weight: "medium", className: "sz-alert-text d-flex align-items-center" }, children),
        onClose && (react_1.default.createElement(__1.SzIcon, { variant: "line", icon: "remove", className: "normal ml-auto cursor-pointer", onClick: onClose }))));
};
exports.SzAlert.defaultProps = {
    variant: 'danger',
    transparent: false
};
exports.default = exports.SzAlert;
